<template>
  <page-main>
    <div class="container">
      <div class="page-border">
        <query v-model="query" keyword="帳號"> </query>
        <btn-group
          :load="reload"
          :insert="insert"
          :del="del"
          :deleteItems="deleteItem.length"
        >
          <!-- <b-button variant="info" @click="updateData">更新資料</b-button> -->
        </btn-group>
      </div>
      <div class="page-border">
        <table class="table">
          <thead>
            <tr>
              <th style="width:30px;"></th>
              <th>帳號</th>
              <th>啟用</th>
            </tr>
          </thead>
          <tr v-for="item in tableData.value" :key="item.MemberID">
            <td data-th="選擇">
              <input
                type="checkbox"
                v-model="deleteItem"
                :value="item.MemberID"
              />
            </td>
            <td data-th="帳號">
              <b-button size="sm" variant="link" @click="edit(item.MemberID)">{{
                item.Account
              }}</b-button>
            </td>
            <td data-th="帳號">{{ item.Enabled | true }}</td>
          </tr>
        </table>

        <pagination
          v-model="pager"
          :rows="tableData.count"
          :rowperpage="10"
          @paging="load"
        ></pagination>
      </div>
    </div>
    <Detail
      id="info"
      :modalkey="modalkey"
      @reload="reload"
      @edit="edit"
    ></Detail>
  </page-main>
</template>

<script>
import Detail from "./memberDetail.vue";
import { master } from "@/views";
export default master({
  name: "member",
  api: "/api/member/",
  components: { Detail },
  filters: {
    true: function(value) {
      return value ? "✔" : "";
    },
  },
  //   methods: {
  //     updateData: function() {
  //       console.log("synchronize start");
  //       this.$http({
  //         method: "get",
  //         url: "api/Identity/UpdateApplicationClassID",
  //       })
  //         .catch((err) => console.log("error"))
  //         .finally(() => console.log("synchronize end"));
  //     },
  //   },
});
</script>

<style></style>
